module.exports = __webpack_public_path__ + "static/profile-1aa7ef3b37bf811d0093b97384bc3b1c.jpg";